function initializeLanguageToggle() {
  const toggleButtons = document.querySelectorAll('.toggle-button');
  const localeContents = document.querySelectorAll('.locale-content');
  
  toggleButtons.forEach(button => {
    button.addEventListener('click', function() {
      const selectedLocale = this.dataset.locale;
      console.log('Selected locale:', selectedLocale);
      
      toggleButtons.forEach(btn => {
        btn.classList.remove('active');
      });
      this.classList.add('active');
      
      localeContents.forEach(content => {
        content.classList.remove('active');
        if (content.dataset.locale === selectedLocale) {
          content.classList.add('active');
          console.log('Activating content for locale:', selectedLocale);
        }
      });
    });
  });
}

// Destroy carousel on this event
// Ref: https://m.phillydevshop.com/turbolinks-5-and-datatables-a882c29d6eff
document.addEventListener('turbolinks:before-cache', () => {
  if (window.exchangeContainer != null) {
    window.exchangeContainer.destroy();
    window.exchangeContainer = null;
  }
});

function initializeVoucherSwipeAndModals() {
  const areaEl = document.querySelector('#swipe-area');
  const noteEl = document.querySelector('#swipe-area .note');
  const continueBtn = document.querySelector('#continue');
  const confirmBtn = document.querySelector('#confirm');
  const toggleMenuBtn = document.querySelector('#toggleMenu');
  const closeMenuBtn = document.querySelector('#closeMenu');
  const receptionPlacesMenuWrapper = document.querySelector('#receptionPlaces');
  const receptionPlacesMenu = document.querySelector('#receptionPlaces ul');
  const receptionPlaces = document.querySelectorAll('#receptionPlaces li');
  const backBtn = document.querySelector('#back');
  const receptionPlaceEl = document.querySelector('#reception-place');
  let selectedOption = null;
  let initialX = null;

  if (!areaEl) return;

  if (continueBtn) {
    continueBtn.addEventListener('touchend', handleContinueBtnTouchEnd);
  }
  
  if (confirmBtn) {
    confirmBtn.addEventListener('touchend', handleconfirmBtnTouchEnd);
  }
  
  if (backBtn) {
    backBtn.addEventListener('touchend', () => {
      $('#modal-ticket-final-confirm').modal('hide');
      $('#modal-ticket-confirm').modal();
    });
  }

  if (toggleMenuBtn) {
    toggleMenuBtn.addEventListener('touchend', function() {
      receptionPlacesMenuWrapper.classList.toggle('show');
      this.classList.toggle('open');
    });

    if (receptionPlacesMenu) {
      receptionPlacesMenu.addEventListener('touchend', function(event) {
        event.stopPropagation();
        const target = event.target;
        Array.from(this.children).forEach(child => {
          if (child !== target) {
            child.classList.remove('selected');
          }
        });
        target.classList.toggle('selected');
        if (target.classList.contains('selected')) {
          selectedOption = target;
        } else {
          selectedOption = null;
        }
        if (selectedOption) {
          closeMenuBtn.removeAttribute('disabled');
        } else {
          closeMenuBtn.setAttribute('disabled', true);
        }
      });
    }

    if (closeMenuBtn) {
      closeMenuBtn.addEventListener('touchend', function(event) {
        if (this.disabled) {
          return;
        }
        receptionPlacesMenuWrapper.classList.remove('show');
        toggleMenuBtn.classList.remove('open');
        toggleMenuBtn.textContent = selectedOption.textContent;
        toggleMenuBtn.classList.remove('no-selection-error');
      });
    }
  }

  if (areaEl) {
    areaEl.addEventListener('touchstart', handleTouchStart);
    areaEl.addEventListener('touchmove', handleTouchMove);
    areaEl.addEventListener('touchend', handleTouchEnd);
  }

  function handleTouchStart(event) {
    initialX = event.touches[0].clientX;
  }

  function handleTouchMove(event) {
    event.preventDefault();
  }

  function handleTouchEnd(event) {
    if (initialX === null) {
      return;
    }
    // 左スワイプでモーダルが表示される
    if ((event.changedTouches[0].clientX - initialX) < 0) {
      $('#modal-is-staff-or-not').modal();
    }
    initialX = null;
  }

  function handleContinueBtnTouchEnd(event) {
    $('#modal-is-staff-or-not').modal('hide');
    if ($('#modal-ticket-final-confirm').data('resort-code')) {
      $('#modal-ticket-final-confirm').modal();
      return;
    }
    $('#modal-ticket-confirm').modal();
  }

  function handleconfirmBtnTouchEnd(event) {
    if (toggleMenuBtn !== null) {
      if (!selectedOption) {
        toggleMenuBtn.classList.add('no-selection-error');
        return;
      }
      if (receptionPlaceEl) {
        receptionPlaceEl.textContent = selectedOption.textContent;
      }
      
      const possibleSelectors = [
        'input[name="voucher[reception_number]"]',
        'input[name="reception_number"]' 
      ];
      
      for (const selector of possibleSelectors) {
        const receptionNumEl = document.querySelector(selector);
        if (receptionNumEl) {
          receptionNumEl.value = selectedOption.dataset.number;
          break;
        }
      }
      
      const resortCodeEl = document.querySelector('input[name="resort_code"]');
      if (resortCodeEl) {
        resortCodeEl.value = selectedOption.dataset.resortCode;
      }
    }
    $('#modal-ticket-confirm').modal('hide');
    $('#modal-ticket-final-confirm').modal();
  }
}

document.addEventListener('turbolinks:load', () => {
  initializeLanguageToggle();
  initializeVoucherSwipeAndModals();

  // キーパッド
  window.currentCodeIndex = 0;
  const codeInputs = document.getElementsByClassName('js-exchange-code');
  const numKeys    = document.getElementsByClassName('js-exchange-key');
  const resetCode  = () => {
    window.currentCodeIndex = 0;
    for (let i = 0; i < codeInputs.length; i += 1) {
      codeInputs[i].value = '';
    }
  };

  const handleKeyClick = (event) => {
    if (window.currentCodeIndex > 3) {
      window.currentCodeIndex = 0;
      resetCode();
    }
    const keyNum = event.target.getAttribute('data-key');
    codeInputs[window.currentCodeIndex].value = keyNum;
    window.currentCodeIndex += 1;
  };

  for (let i = 0; i < numKeys.length; i += 1) {
    numKeys[i].onclick = handleKeyClick;
  }

  // リセットボタン
  const resetBtn = document.querySelector('.js-exchange-code-reset');
  if (resetBtn != null) {
    resetBtn.onclick = resetCode;
  }
});
